// KVグラデーションアニメーション（元: brand/sustainability/contents/_kv.php）
// brand/sustainability と brand/repair-service で共有。
// 使用する要素: <div id="canvas-container" data-kv-images="url1,url2,...">
//                 <canvas id="main-canvas"></canvas>
//                 <div id="loading-overlay"></div>
//               </div>
// 画像URLは data-kv-images 属性（カンマ区切り）で渡す。
(function () {
  function init() {
    const container = document.getElementById('canvas-container');
    if (!container) return;

    const imagePaths = (container.dataset.kvImages || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!imagePaths.length) return;

    const canvas = document.getElementById('main-canvas');
    const ctx = canvas.getContext('2d', {
      willReadFrequently: false,
      alpha: false,
      desynchronized: true // 非同期レンダリングで高速化
    });

    let images = [];
    let currentImageIndex = 0;
    let nextImageIndex = 1;
    let loadedCount = 0;

    // 色情報（全画像分を事前取得）
    let allColors = []; // 各画像の色配列
    let currentColors = [];
    let nextColors = [];
    let blobs = [];
    let colorsReady = false; // 全色取得完了フラグ

    // ノイズテクスチャ
    let noiseCanvas = null;
    let noiseCtx = null;

    // パラメータ
    let params = {
      numColors: 12,
      initialFadeInDuration: 3000,
      fadeInDuration: 700,
      imageDuration: 2000,
      gradientDuration: 1000,
      dissolveDuration: 2500,
      colorTransitionDuration: 1500,
      convergeDuration: 3500,
      flowSpeed: 0.6,
      waveSpeed: 0.75,
      blobRadius: 0.55,
      textAvoidRadius: 0.2,
      centerText: 'YOUR TEXT',
      maxBlur: 45,
      noiseEnabled: true // ノイズのオンオフ
    };

    // フェーズ管理
    let currentPhase = 'loading';
    let phaseStartTime = 0;
    let isFirstCycle = true; // 最初のサイクルかどうか

    // 中央の避ける領域
    let avoidZone = {
      x: 0.5,
      y: 0.5,
      radius: 0.2
    };

    // 画像読み込み
    function loadImages() {
      imagePaths.forEach((path, index) => {
        const img = new Image();
        img.onload = function () {
          images[index] = img;
          loadedCount++;

          if (loadedCount === imagePaths.length) {
            // 全画像読み込み完了後、全ての色を事前取得
            for (let i = 0; i < images.length; i++) {
              allColors[i] = extractMainColors(images[i], params.numColors);
            }

            // 最初の画像の色を設定
            currentColors = allColors[0];
            nextColors = allColors[1];
            initBlobs(currentColors);

            colorsReady = true;
            phaseStartTime = Date.now();
            currentPhase = 'initialGradient'; // 最初はグラデーションから開始

            // ローディングオーバーレイをフェードアウト
            const loadingOverlay = document.getElementById('loading-overlay');
            if (loadingOverlay) {
              loadingOverlay.classList.add('fade-out');

              // フェードアウト完了後に要素を削除
              setTimeout(() => {
                loadingOverlay.remove();
              }, 500);
            }

            animate();
          }
        };
        img.src = path;
      });
    }

    // ノイズテクスチャを生成（1pxの細かいノイズ）
    function generateNoiseTexture() {
      const size = 512; // より大きいサイズで細かいノイズ
      noiseCanvas = document.createElement('canvas');
      noiseCanvas.width = size;
      noiseCanvas.height = size;
      noiseCtx = noiseCanvas.getContext('2d');

      const imageData = noiseCtx.createImageData(size, size);
      const data = imageData.data;

      // 1pxごとにランダムなノイズ
      for (let i = 0; i < data.length; i += 4) {
        const noise = Math.random() * 255;
        data[i] = noise; // R
        data[i + 1] = noise; // G
        data[i + 2] = noise; // B
        data[i + 3] = 30; // A (ほどよく見える: 約12%の不透明度)
      }

      noiseCtx.putImageData(imageData, 0, 0);
    }

    // ノイズパターンをキャッシュ
    let noisePattern = null;

    // ノイズを描画（静止）
    function drawNoise(time) {
      if (!noiseCanvas || !params.noiseEnabled) return;

      // パターンを初回のみ生成してキャッシュ
      if (!noisePattern) {
        noisePattern = ctx.createPattern(noiseCanvas, 'repeat');
      }

      ctx.save();
      ctx.globalCompositeOperation = 'overlay';
      ctx.globalAlpha = 0.25;
      ctx.fillStyle = noisePattern;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.restore();
    }

    function resizeCanvas() {
      canvas.width = container.clientWidth;
      canvas.height = container.clientHeight;
    }

    window.addEventListener('resize', resizeCanvas);
    resizeCanvas();

    function initBlobs(colors) {
      blobs = [];
      for (let i = 0; i < colors.length; i++) {
        const color = colors[i];
        blobs.push({
          x: color.x,
          y: color.y,
          originalX: color.x,
          originalY: color.y,
          targetX: color.x, // 遷移先の位置
          targetY: color.y,
          radius: params.blobRadius,
          colorIndex: i,
          phase: Math.random() * Math.PI * 2,
          speed: 0.5 + Math.random() * 0.5,
          scaleX: 1,
          scaleY: 1,
          rotation: Math.random() * Math.PI * 2,
          deformPhase: Math.random() * Math.PI * 2
        });
      }
    }

    function extractMainColors(image, numColors) {
      // オフスクリーンキャンバスを使用（画面に表示されない）
      const tempCanvas = document.createElement('canvas');
      const tempCtx = tempCanvas.getContext('2d', {
        willReadFrequently: false
      });

      // サンプリングサイズを小さくして軽量化
      const sampleSize = 50;
      tempCanvas.width = sampleSize;
      tempCanvas.height = sampleSize;

      tempCtx.drawImage(image, 0, 0, sampleSize, sampleSize);
      const imageData = tempCtx.getImageData(0, 0, sampleSize, sampleSize);

      let sampledColors = [];
      const step = 10; // ステップを大きくして軽量化

      for (let y = 0; y < sampleSize; y += step) {
        for (let x = 0; x < sampleSize; x += step) {
          const index = (y * sampleSize + x) * 4;
          sampledColors.push({
            r: imageData.data[index],
            g: imageData.data[index + 1],
            b: imageData.data[index + 2],
            x: x / sampleSize,
            y: y / sampleSize
          });
        }
      }

      return kMeansClustering(sampledColors, numColors);
    }

    function kMeansClustering(colors, k) {
      let centers = [];
      for (let i = 0; i < k; i++) {
        const randomColor = colors[Math.floor(Math.random() * colors.length)];
        centers.push({
          r: randomColor.r,
          g: randomColor.g,
          b: randomColor.b,
          x: randomColor.x,
          y: randomColor.y
        });
      }

      // イテレーション回数を2回に削減（視覚的影響なし）
      for (let iter = 0; iter < 2; iter++) {
        let clusters = Array(k).fill(null).map(() => []);

        for (let c of colors) {
          let minDist = Infinity;
          let closestCenter = 0;

          for (let i = 0; i < k; i++) {
            const dist = colorDistance(c, centers[i]);
            if (dist < minDist) {
              minDist = dist;
              closestCenter = i;
            }
          }

          clusters[closestCenter].push(c);
        }

        for (let i = 0; i < k; i++) {
          if (clusters[i].length > 0) {
            let avgR = 0,
              avgG = 0,
              avgB = 0,
              avgX = 0,
              avgY = 0;
            for (let c of clusters[i]) {
              avgR += c.r;
              avgG += c.g;
              avgB += c.b;
              avgX += c.x;
              avgY += c.y;
            }
            centers[i] = {
              r: avgR / clusters[i].length,
              g: avgG / clusters[i].length,
              b: avgB / clusters[i].length,
              x: avgX / clusters[i].length,
              y: avgY / clusters[i].length
            };
          }
        }
      }

      return centers;
    }

    function colorDistance(c1, c2) {
      return Math.sqrt(
        Math.pow(c1.r - c2.r, 2) +
        Math.pow(c1.g - c2.g, 2) +
        Math.pow(c1.b - c2.b, 2)
      );
    }

    function lerpColor(c1, c2, t) {
      return {
        r: c1.r + (c2.r - c1.r) * t,
        g: c1.g + (c2.g - c1.g) * t,
        b: c1.b + (c2.b - c1.b) * t,
        x: c1.x + (c2.x - c1.x) * t,
        y: c1.y + (c2.y - c1.y) * t
      };
    }

    function drawCoverImage(img, alpha = 1.0) {
      const imgAspect = img.width / img.height;
      const canvasAspect = canvas.width / canvas.height;

      let drawWidth, drawHeight, offsetX, offsetY;

      if (canvasAspect > imgAspect) {
        drawWidth = canvas.width;
        drawHeight = canvas.width / imgAspect;
        offsetX = 0;
        offsetY = (canvas.height - drawHeight) / 2;
      } else {
        drawHeight = canvas.height;
        drawWidth = canvas.height * imgAspect;
        offsetX = (canvas.width - drawWidth) / 2;
        offsetY = 0;
      }

      ctx.globalAlpha = alpha;
      ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
      ctx.globalAlpha = 1;
    }

    function drawOrganicGradient(colors, alpha = 1.0, time = 0, transitionProgress = null, addNoise = false) {
      // アルファが0の場合のみスキップ
      if (alpha <= 0) return;

      // 背景を最初の色で塗る（アルファを適用）
      if (colors.length > 0) {
        ctx.fillStyle = `rgba(${Math.round(colors[0].r)}, ${Math.round(colors[0].g)}, ${Math.round(colors[0].b)}, ${alpha})`;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
      }

      // 各blobを更新して描画
      for (let i = 0; i < blobs.length; i++) {
        const blob = blobs[i];
        const flowSpeed = params.flowSpeed;
        const waveSpeed = params.waveSpeed;

        // メインの流れ
        const flowX = Math.sin(time * flowSpeed * 0.3 + blob.phase) * 0.25;
        const flowY = Math.cos(time * flowSpeed * 0.25 + blob.phase * 1.3) * 0.25;

        // 小さな波
        const waveX = Math.sin(time * waveSpeed * 2 + blob.phase * 2) * 0.08;
        const waveY = Math.cos(time * waveSpeed * 1.7 + blob.phase * 2.5) * 0.08;

        // 回転
        const rotation = time * 0.05;
        let rotX = Math.cos(rotation + blob.phase) * 0.15;
        let rotY = Math.sin(rotation + blob.phase) * 0.15;

        // 基本位置（遷移中の場合は補間）
        let baseX, baseY;
        if (transitionProgress !== null) {
          // 色遷移中: originalXからtargetXへ滑らかに補間
          baseX = blob.originalX + (blob.targetX - blob.originalX) * transitionProgress;
          baseY = blob.originalY + (blob.targetY - blob.originalY) * transitionProgress;
        } else {
          baseX = blob.originalX;
          baseY = blob.originalY;
        }

        let targetX = baseX + flowX + waveX + rotX;
        let targetY = baseY + flowY + waveY + rotY;

        // 中央のテキストを避ける
        if (avoidZone.radius > 0) {
          const dx = targetX - avoidZone.x;
          const dy = targetY - avoidZone.y;
          const dist = Math.sqrt(dx * dx + dy * dy);

          if (dist < avoidZone.radius) {
            const pushForce = (avoidZone.radius - dist) / avoidZone.radius;
            targetX += (dx / dist) * pushForce * 0.3;
            targetY += (dy / dist) * pushForce * 0.3;
          }
        }

        blob.x = targetX;
        blob.y = targetY;

        // 有機的な形状変化
        blob.scaleX = 1 + Math.sin(time * 0.3 + blob.deformPhase) * 0.4;
        blob.scaleY = 1 + Math.cos(time * 0.25 + blob.deformPhase * 1.3) * 0.4;
        blob.rotation = time * 0.1 + blob.phase;

        // グラデーションを描画
        const x = blob.x * canvas.width;
        const y = blob.y * canvas.height;

        const baseRadius = blob.radius * Math.max(canvas.width, canvas.height);
        const sizeVariation = 1 + Math.sin(time * 0.4 + blob.phase) * 0.2;

        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(blob.rotation);
        ctx.scale(blob.scaleX, blob.scaleY);

        const color = colors[i % colors.length];
        const r = Math.round(color.r);
        const g = Math.round(color.g);
        const b = Math.round(color.b);
        const gradient = ctx.createRadialGradient(0, 0, 0, 0, 0, baseRadius * sizeVariation);

        gradient.addColorStop(0, `rgba(${r}, ${g}, ${b}, ${0.8 * alpha})`);
        gradient.addColorStop(0.4, `rgba(${r}, ${g}, ${b}, ${0.6 * alpha})`);
        gradient.addColorStop(0.7, `rgba(${r}, ${g}, ${b}, ${0.3 * alpha})`);
        gradient.addColorStop(1, `rgba(${r}, ${g}, ${b}, 0)`);

        ctx.fillStyle = gradient;
        ctx.fillRect(-baseRadius * 2, -baseRadius * 2, baseRadius * 4, baseRadius * 4);

        ctx.restore();
      }

      // ノイズを追加（グラデーション表示時のみ）
      if (addNoise && alpha > 0.1) {
        drawNoise(time);
      }
    }

    function animate() {
      const now = Date.now();
      const elapsed = now - phaseStartTime;
      const time = now * 0.001;

      // 現在表示する画像を取得
      const currentImg = images[currentImageIndex];

      // 描画（白背景を削除して明滅を防ぐ）

      if (currentPhase === 'initialGradient') {
        // 最初だけ白背景から開始
        ctx.fillStyle = '#fff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        // 最初のグラデーション表示
        drawOrganicGradient(currentColors, 1.0, time, null, true);
      } else if (currentPhase === 'gradient') {
        // グラデーション表示
        drawOrganicGradient(currentColors, 1.0, time, null, true);
      } else if (currentPhase === 'converge') {
        // グラデーションから写真へゆったり切り替わる
        const progress = Math.min(elapsed / params.convergeDuration, 1.0);

        // 滑らかなイージング関数（カクつき防止）
        const smoothProgress = progress * progress * progress * (progress * (progress * 6 - 15) + 10); // smootherstep

        // 連続的な変化（境界なし）
        let blurAmount, imageAlpha, gradientAlpha;

        // グラデーションのアルファ: 1.0 → 0.0 へ非常に滑らかに
        // より高い指数でゆっくり消える
        gradientAlpha = Math.pow(1 - smoothProgress, 4.0);

        // 画像のアルファ: 0.0 → 1.0 へ滑らかに
        // より早めに開始して長く重なる
        const imageStart = 0.05;
        const imageProgress = Math.max(0, (progress - imageStart) / (1 - imageStart));
        const smoothImageProgress = imageProgress * imageProgress * (3 - 2 * imageProgress);
        imageAlpha = smoothImageProgress;

        // ブラー量: maxBlur → 0 へ非常に滑らかに
        // より緩やかに減少させる
        blurAmount = params.maxBlur * Math.pow(1 - smoothImageProgress, 2.0);

        // グラデーションを最後まで描画（閾値チェックなし、完全にフェードアウト）
        drawOrganicGradient(currentColors, gradientAlpha, time);

        // 画像を描画
        // ブラーを滑らかに適用（整数化による段差を防ぐ）
        if (blurAmount > 0.5) {
          ctx.filter = `blur(${blurAmount.toFixed(1)}px)`;
        }
        drawCoverImage(currentImg, imageAlpha);
        ctx.filter = 'none';
      } else if (currentPhase === 'image') {
        // 写真表示
        drawCoverImage(currentImg, 1.0);
      } else if (currentPhase === 'dissolve') {
        // 写真からグラデーションへゆったり切り替わる
        const progress = Math.min(elapsed / params.dissolveDuration, 1.0);

        // 滑らかなイージング関数（カクつき防止）
        const smoothProgress = progress * progress * progress * (progress * (progress * 6 - 15) + 10); // smootherstep

        // 連続的な変化（境界なし）
        let blurAmount, imageAlpha, gradientAlpha;

        // 画像のアルファ: 1.0 → 0.0 へ滑らかに
        imageAlpha = Math.pow(1 - smoothProgress, 2.5);

        // グラデーションのアルファ: 0.0 → 1.0 へ滑らかに
        // 少し遅れて開始することで重なりを作る
        const gradientStart = 0.2;
        const gradientProgress = Math.max(0, (progress - gradientStart) / (1 - gradientStart));
        const smoothGradientProgress = gradientProgress * gradientProgress * (3 - 2 * gradientProgress);
        gradientAlpha = smoothGradientProgress;

        // ブラー量: 0 → maxBlur へ滑らかに
        // グラデーションのアルファに合わせて増加
        blurAmount = params.maxBlur * Math.pow(smoothGradientProgress, 1.5);

        // グラデーションを描画（現在の画像の色を使用）
        if (gradientAlpha > 0.01) {
          drawOrganicGradient(currentColors, gradientAlpha, time);
        }

        // 画像を描画
        if (imageAlpha > 0.01) {
          // ブラーを滑らかに適用（整数化による段差を防ぐ）
          if (blurAmount > 1) {
            ctx.filter = `blur(${blurAmount.toFixed(1)}px)`;
          }
          drawCoverImage(currentImg, imageAlpha);
          ctx.filter = 'none';
        }
      } else if (currentPhase === 'currentGradient') {
        // 現在の画像のグラデーション表示
        drawOrganicGradient(currentColors, 1.0, time, null, true);
      } else if (currentPhase === 'colorTransition') {
        // 現在のグラデーションから次のグラデーションへ色が変化
        const progress = Math.min(elapsed / params.colorTransitionDuration, 1.0);

        // 滑らかなイージング
        const smoothProgress = progress * progress * (3 - 2 * progress);

        // 色を補間
        const transitionColors = currentColors.map((c, i) =>
          lerpColor(c, nextColors[i % nextColors.length], smoothProgress)
        );

        // グラデーションを描画（位置も補間）
        drawOrganicGradient(transitionColors, 1.0, time, smoothProgress, true);
      } else if (currentPhase === 'gradient') {
        // 次の画像のグラデーション表示
        drawOrganicGradient(currentColors, 1.0, time, null, true);
      }

      // フェーズ遷移（描画の後に行う）
      if (currentPhase === 'initialGradient' && elapsed > params.gradientDuration) {
        // 最初のグラデーション→最初の写真
        currentPhase = 'converge';
        phaseStartTime = now;
        isFirstCycle = false;
      } else if (currentPhase === 'converge' && elapsed > params.convergeDuration) {
        // 写真表示へ
        currentPhase = 'image';
        phaseStartTime = now;
      } else if (currentPhase === 'image' && elapsed > params.imageDuration) {
        // 写真→現在の画像のグラデーションへ溶解
        currentPhase = 'dissolve';
        phaseStartTime = now;
      } else if (currentPhase === 'dissolve' && elapsed > params.dissolveDuration) {
        // 現在の画像のグラデーション表示へ
        currentPhase = 'currentGradient';
        phaseStartTime = now;
      } else if (currentPhase === 'currentGradient' && elapsed > params.gradientDuration) {
        // 現在のグラデーション→次のグラデーションへ色遷移
        currentPhase = 'colorTransition';
        phaseStartTime = now;
        // 次の画像の色を事前取得した配列から取得
        nextImageIndex = (currentImageIndex + 1) % images.length;
        nextColors = allColors[nextImageIndex];

        // blobのターゲット位置を更新
        for (let i = 0; i < blobs.length; i++) {
          blobs[i].targetX = nextColors[i % nextColors.length].x;
          blobs[i].targetY = nextColors[i % nextColors.length].y;
        }
      } else if (currentPhase === 'colorTransition' && elapsed > params.colorTransitionDuration) {
        // 色遷移完了直前に色とblobの位置を更新
        currentColors = allColors[nextImageIndex];
        currentImageIndex = nextImageIndex;

        // blobの基準位置を更新（遷移完了）
        for (let i = 0; i < blobs.length; i++) {
          blobs[i].originalX = blobs[i].targetX;
          blobs[i].originalY = blobs[i].targetY;
        }

        // 次の画像のグラデーション表示へ
        currentPhase = 'gradient';
        phaseStartTime = now;
      } else if (currentPhase === 'gradient' && elapsed > params.gradientDuration) {
        // グラデーション→次の写真へ
        currentPhase = 'converge';
        phaseStartTime = now;
      }

      requestAnimationFrame(animate);
    }

    // 初期化
    generateNoiseTexture();
    loadImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
